import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Guardian } from '@xaamin/guardian';
import { Button, Row, Col } from 'react-bootstrap';

import EmpresasList from './list/EmpresasList';
import EmpresasItemActions from './list/components/EmpresasItemActions';

class Empresas extends Component {

  state = {
    selectedRowKeys: [],
    selectedRows: []
  }

  componentDidMount() {
    window.setAppTitle('Empresas');
  }

  handleOnRowSelectionChange = ({selectedRowKeys, selectedRows}) => {
    this.setState({
      selectedRowKeys,
      selectedRows
    });
  }

  handleOnRowClick = (data) => {
    this.props.history.replace({
      pathname: `/cuenta/empresas/${data.id}/info`,
      state: {
        data: {...data}
      }
    });
  }

  render() {
    const { selectedRowKeys, selectedRows } = this.state;

    return (
      <div>
        <Row className="mb-3">
          <Col>
            { Guardian.allows('empresas.create') && Guardian.allows('empresas.crear') && (
              <Link to="/cuenta/empresas/registrar" className="mr-3">
                <Button>
                  Nueva Empresa
                </Button>
              </Link>
            )}

            { selectedRowKeys.length > 0 && (
                <EmpresasItemActions
                  selectedRowKeys={ selectedRowKeys }
                  selectedRows={ selectedRows }
                />
              )
            }
          </Col>

          <Col className="text-right">
            <h5 className="pt-2">
              Empresas
            </h5>
          </Col>
        </Row>

        { Guardian.allows('empresas.listar') && (
          <EmpresasList
            onRowClick={ this.handleOnRowClick }
            onRowSelectionChange={ this.handleOnRowSelectionChange }
          />
        )}

      </div>
    )
  }
}

export default Empresas;